/** Luma calendar id — override with VITE_LUMA_CALENDAR_ID if needed. */
const LUMA_CALENDAR_ID =
  import.meta.env.VITE_LUMA_CALENDAR_ID?.trim() || "cal-9AZ6xW7GHRUpC5S";

/** Embedded events list for the homepage iframe. */
export const LUMA_CALENDAR_EMBED_URL =
  import.meta.env.VITE_LUMA_CALENDAR_EMBED_URL?.trim() ||
  `https://luma.com/embed/calendar/${LUMA_CALENDAR_ID}/events`;

/** Public calendar page — set VITE_LUMA_FOLLOW_URL to override. */
export const LUMA_FOLLOW_URL =
  import.meta.env.VITE_LUMA_FOLLOW_URL?.trim() ||
  `https://luma.com/${LUMA_CALENDAR_ID}`;

/** Sponsor inquiry link — set VITE_SPONSOR_CONTACT_URL to override. */
export const SPONSOR_CONTACT_URL =
  import.meta.env.VITE_SPONSOR_CONTACT_URL?.trim() ||
  "https://www.linkedin.com/in/stephansmithbc93/";

export const NEXT_EVENT = {
  label: "Upcoming events",
  note: "Subscribe on Luma to get notified when registration opens.",
} as const;

export const LAST_EVENT = {
  label: "Last event",
  date: "Thursday, May 14, 2026",
  time: "5:00 – 7:30 PM EDT",
  venue: "Samuel Adams Boston Brewery — Jamaica Plain",
  address: "30 Germania St, Boston, MA 02130",
} as const;
